// Multi-language dictionary for Carol Tierbetreuung
// Supports: de (default), pt, en

export const LANGS = [
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "pt", label: "PT", name: "Português" },
  { code: "en", label: "EN", name: "English" },
];

export const translations = {
  de: {
    nav: {
      home: "Home",
      services: "Angebot",
      about: "Über uns",
      gallery: "Galerie",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Jetzt anfragen",
    },
    hero: {
      title: "Ihr Haustier ist bei uns in den besten Händen",
      subtitle:
        "Liebevolle Betreuung für Hunde und Katzen in Embrach. Weil Ihr Vierbeiner mehr als nur Fürsorge verdient — er verdient echte Zuneigung.",
      ctaPrimary: "Angebot entdecken",
      ctaSecondary: "Kontakt aufnehmen",
      badge: "Mit Liebe seit 2023",
    },
    banner: {
      title: "Babypause!",
      text: "Ich befinde mich aktuell im Mutterschaftsurlaub und nehme vorübergehend keine neuen Aufträge an. Möchten Sie informiert werden, sobald ich zurück bin?",
      cta: "Warteliste beitreten",
      formTitle: "Auf die Warteliste",
      formSubtitle:
        "Hinterlassen Sie Ihren Namen und Ihre E-Mail — ich melde mich, sobald ich wieder verfügbar bin.",
      namePh: "Ihr Name",
      emailPh: "Ihre E-Mail",
      submit: "Eintragen",
      success: "Danke! Sie sind auf der Warteliste 🐾",
      already: "Diese E-Mail ist bereits eingetragen.",
    },
    services: {
      title: "Was wir für Sie tun",
      subtitle:
        "Drei Angebote, ein gemeinsames Ziel: Ihr Tier soll sich rundum geborgen fühlen.",
      tax: "Preise exkl. MwSt.",
      walk: {
        title: "Spaziergänge",
        text: "Jeder Spaziergang ist ein kleines Abenteuer. Ihr Hund geht voller Energie raus und kommt glücklich, müde und mit wedelndem Schwanz zurück.",
        p1: "Pro Spaziergang & Hund",
        p1v: "CHF 35",
        p2: "Zusätzlicher Hund (gleiche Familie)",
        p2v: "CHF 25",
        p3: "Einzelspaziergang (auf Anfrage)",
        p3v: "CHF 50",
      },
      day: {
        title: "Tagesbetreuung",
        text: "Eine sichere Umgebung voller Spiel und Gesellschaft. Ihr Hund sozialisiert sich, hat Spass und behält seinen Rhythmus, während Sie arbeiten oder reisen.",
        p1: "Ganztags",
        p1v: "CHF 65",
        p2: "Halbtags",
        p2v: "CHF 50",
      },
      cat: {
        title: "Katzenbetreuung",
        text: "Katzen brauchen Aufmerksamkeit — am liebsten zu Hause. Tägliche Besuche zum Füttern, Spielen und damit Ihre Samtpfote sich geliebt fühlt.",
        p1: "Besuch 1× täglich",
        p1v: "CHF 35",
        p2: "Besuch 2× täglich",
        p2v: "CHF 55",
        p3: "Jede weitere Katze (gleicher Haushalt)",
        p3v: "+CHF 5/Tag",
      },
    },
    about: {
      kicker: "Über uns",
      title: "Hallo, ich bin Carol!",
      p1: "Ich bin Caroline Sousa, und meine Leidenschaft für Tiere begleitet mich seit meiner Kindheit. Als Petsitterin in Embrach kümmere ich mich um Hunde und Katzen mit derselben Zuneigung, die ich mir für meine eigenen Tiere wünsche. Jedes Tier hat seine eigene Persönlichkeit — und genau das liebe ich daran.",
      p2: "Wenn ich Ihren Vierbeiner betreue, sind Sie nicht einfach eine Buchung. Sie werden Teil meiner kleinen tierischen Familie.",
      badge: "Mit Liebe seit 2023",
    },
    why: {
      title: "Was uns besonders macht",
      subtitle: "Vier Gründe, warum Tiereltern uns vertrauen.",
      items: [
        { title: "Vertraute Umgebung", text: "Betreuung zu Hause, wo Ihr Tier sich am wohlsten fühlt." },
        { title: "Echte Zuneigung", text: "Kein Job. Einfach Liebe zu Tieren." },
        { title: "Lokal & zuverlässig", text: "In Embrach, immer erreichbar." },
        { title: "Offiziell zertifiziert", text: "FBA-zertifiziert durch CertoDog." },
      ],
    },
    gallery: {
      title: "Momente voller Freude",
      subtitle: "Ein kleiner Einblick in unseren Alltag mit Hunden und Katzen.",
    },
    testimonials: {
      title: "Was Tiereltern sagen",
      subtitle: "Beispiel-Stimmen — werden mit echten Bewertungen ersetzt.",
      note: "* Platzhalter-Texte. Werden später durch echte Bewertungen ersetzt.",
      items: [
        {
          name: "Maria & Max",
          pet: "🐕",
          text: "Carol kümmert sich um Max wie um ihren eigenen Hund. Wir reisen entspannt — Max liebt sie!",
        },
        {
          name: "Daniel & Luna",
          pet: "🐱",
          text: "Luna ist sehr scheu, aber bei Carol blüht sie auf. Tägliche Updates mit Fotos — perfekt.",
        },
        {
          name: "Sandra & Bobby",
          pet: "🐕",
          text: "Zuverlässig, herzlich und immer erreichbar. Wir empfehlen Carol von ganzem Herzen.",
        },
      ],
    },
    faq: {
      title: "Häufige Fragen",
      subtitle: "Alles, was Sie vor der ersten Buchung wissen möchten.",
      items: [
        {
          q: "Wie läuft die erste Kontaktaufnahme ab?",
          a: "Schreiben Sie mir kurz über das Formular oder per Telefon. Wir vereinbaren ein kostenloses Kennenlerngespräch bei Ihnen zuhause, damit ich Ihr Tier und seine Routinen entspannt kennenlernen kann.",
        },
        {
          q: "Betreuen Sie auch Welpen oder ältere Hunde?",
          a: "Ja, sehr gerne. Welpen und Senioren brauchen besondere Aufmerksamkeit — wir passen Tempo, Spaziergänge und Pausen ihren Bedürfnissen an.",
        },
        {
          q: "Was passiert, wenn mein Tier krank wird?",
          a: "Ich informiere Sie sofort und folge Ihren Anweisungen. Im Notfall bringe ich Ihr Tier zu Ihrem Tierarzt oder, falls nicht erreichbar, zur nächsten Notfallpraxis.",
        },
        {
          q: "Können Sie auch kurzfristig buchen?",
          a: "Wenn meine Verfügbarkeit es zulässt — ja. Bitte rufen Sie direkt an, dann finden wir gemeinsam die beste Lösung.",
        },
        {
          q: "Sind die Preise verhandelbar?",
          a: "Die Preise sind fair kalkuliert. Bei Langzeitbuchungen oder mehreren Tieren aus dem gleichen Haushalt finden wir gerne eine individuelle Lösung.",
        },
      ],
    },
    contact: {
      title: "Schreiben Sie uns!",
      subtitle:
        "Erzählen Sie mir von Ihrem Vierbeiner. Ich melde mich innerhalb von 24 Stunden zurück.",
      info: "Kontakt-Infos",
      hours: "Mo – Fr · 08:00 – 18:30 Uhr",
      city: "Embrach, Kanton Zürich",
      name: "Name",
      phone: "Telefonnummer",
      email: "E-Mail",
      location: "Ort / Platz",
      service: "Betreuungsart",
      spaziergang: "Spaziergang",
      tagesbetreuung: "Tagesbetreuung",
      katzenbetreuung: "Katzenbetreuung",
      dogCount: "Wie viele Hunde?",
      dogSize: "Hundegrösse",
      sizeSmall: "Kleiner (bis 10 kg)",
      sizeLarge: "Grosse (ab 10 kg)",
      message: "Nachricht",
      submit: "Senden",
      success: "Danke! Wir melden uns bald bei Ihnen 🐾",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      placeholderName: "Wie heissen Sie?",
      placeholderPhone: "+41 …",
      placeholderEmail: "ihre@email.ch",
      placeholderLocation: "Strasse / Ort",
      placeholderMessage: "Erzählen Sie kurz von Ihrem Tier und Ihren Wünschen…",
    },
    footer: {
      tagline: "Liebevolle Petsitterin in Embrach.",
      quick: "Schnellzugriff",
      legal: "Rechtliches",
      agb: "AGB",
      privacy: "Datenschutz",
      social: "Folgen Sie uns",
      rights: "© 2026 Caroline Sousa · carol-tierbetreuung.ch",
    },
  },

  pt: {
    nav: {
      home: "Início",
      services: "Serviços",
      about: "Sobre",
      gallery: "Galeria",
      faq: "FAQ",
      contact: "Contato",
      cta: "Pedir agora",
    },
    hero: {
      title: "Seu pet está nas melhores mãos com a gente",
      subtitle:
        "Cuidado carinhoso para cães e gatos em Embrach. Porque seu peludo merece mais do que cuidado — ele merece afeto de verdade.",
      ctaPrimary: "Ver serviços",
      ctaSecondary: "Entrar em contato",
      badge: "Com amor desde 2023",
    },
    banner: {
      title: "Licença-maternidade!",
      text: "Estou no momento em licença-maternidade e temporariamente não aceito novos clientes. Quer ser avisado quando eu voltar?",
      cta: "Entrar na lista de espera",
      formTitle: "Lista de espera",
      formSubtitle:
        "Deixe seu nome e e-mail — entro em contato assim que voltar a atender.",
      namePh: "Seu nome",
      emailPh: "Seu e-mail",
      submit: "Cadastrar",
      success: "Obrigada! Você está na lista 🐾",
      already: "Esse e-mail já está cadastrado.",
    },
    services: {
      title: "O que fazemos por você",
      subtitle: "Três serviços com um objetivo: seu pet se sentir em casa.",
      tax: "Preços sem IVA",
      walk: {
        title: "Passeios",
        text: "Cada passeio é uma pequena aventura. Seu cão sai cheio de energia e volta feliz, cansado e abanando o rabo.",
        p1: "Por passeio & cão",
        p1v: "CHF 35",
        p2: "Cão adicional (mesma família)",
        p2v: "CHF 25",
        p3: "Passeio individual (sob consulta)",
        p3v: "CHF 50",
      },
      day: {
        title: "Day Care",
        text: "Um ambiente seguro, cheio de brincadeira e companhia. Seu cão socializa, se diverte e mantém a rotina.",
        p1: "Dia inteiro",
        p1v: "CHF 65",
        p2: "Meio dia",
        p2v: "CHF 50",
      },
      cat: {
        title: "Cuidado de gatos",
        text: "Gatos precisam de atenção — no conforto do próprio lar. Visitas diárias para alimentar, brincar e dar amor.",
        p1: "Visita 1× por dia",
        p1v: "CHF 35",
        p2: "Visita 2× por dia",
        p2v: "CHF 55",
        p3: "Cada gato adicional (mesma casa)",
        p3v: "+CHF 5/dia",
      },
    },
    about: {
      kicker: "Sobre",
      title: "Oi, eu sou a Carol!",
      p1: "Sou a Caroline Sousa e minha paixão por animais me acompanha desde a infância. Como petsitter em Embrach, cuido de cães e gatos com o mesmo carinho que gostaria para meus próprios animais. Cada bichinho tem sua personalidade — e é justamente isso que eu amo.",
      p2: "Quando cuido do seu peludo, você não é só uma reserva. Você passa a fazer parte da minha pequena família animal.",
      badge: "Com amor desde 2023",
    },
    why: {
      title: "O que nos torna especiais",
      subtitle: "Quatro razões pelas quais tutores confiam na gente.",
      items: [
        { title: "Ambiente familiar", text: "Cuidado em casa, onde seu pet se sente melhor." },
        { title: "Afeto real", text: "Não é trabalho. É amor por animais." },
        { title: "Local & confiável", text: "Em Embrach, sempre disponível." },
        { title: "Registrada oficialmente", text: "Autorizada pelo Veterinäramt Kanton Zürich." },
      ],
    },
    gallery: {
      title: "Momentos de pura alegria",
      subtitle: "Um pedacinho do nosso dia a dia com cães e gatos.",
    },
    testimonials: {
      title: "O que os tutores dizem",
      subtitle: "Depoimentos exemplo — serão substituídos por avaliações reais.",
      note: "* Textos provisórios. Serão substituídos por avaliações reais.",
      items: [
        { name: "Maria & Max", pet: "🐕", text: "A Carol cuida do Max como se fosse dela. Viajamos tranquilos." },
        { name: "Daniel & Luna", pet: "🐱", text: "A Luna é tímida, mas com a Carol ela floresce. Updates diários, perfeito." },
        { name: "Sandra & Bobby", pet: "🐕", text: "Confiável, carinhosa e sempre disponível. Recomendamos de coração." },
      ],
    },
    faq: {
      title: "Perguntas frequentes",
      subtitle: "Tudo o que você quer saber antes da primeira reserva.",
      items: [
        { q: "Como é o primeiro contato?", a: "Mande uma mensagem pelo formulário ou ligue. Marcamos uma visita gratuita na sua casa para conhecer o seu pet com calma." },
        { q: "Vocês cuidam de filhotes ou cães idosos?", a: "Sim, com prazer. Filhotes e idosos pedem atenção especial — ajustamos ritmo, passeios e pausas." },
        { q: "E se meu pet ficar doente?", a: "Aviso imediatamente e sigo suas orientações. Em emergência, levo ao seu veterinário ou ao plantão mais próximo." },
        { q: "É possível reservar em cima da hora?", a: "Se houver disponibilidade, sim. Ligue direto e encontramos a melhor solução." },
        { q: "Os preços são negociáveis?", a: "Os preços são justos. Para reservas longas ou múltiplos pets, encontramos uma solução personalizada." },
      ],
    },
    contact: {
      title: "Fale com a gente!",
      subtitle: "Conta sobre o seu peludo. Respondo em até 24 horas.",
      info: "Informações de contato",
      hours: "Seg – Sex · 08:00 – 18:30",
      city: "Embrach, Cantão de Zurique",
      name: "Nome",
      phone: "Telefone",
      email: "E-mail",
      location: "Endereço / Local",
      service: "Tipo de cuidado",
      spaziergang: "Passeio",
      tagesbetreuung: "Day Care",
      katzenbetreuung: "Cuidado de gato",
      dogCount: "Quantos cães?",
      dogSize: "Tamanho do cão",
      sizeSmall: "Pequeno (até 10 kg)",
      sizeLarge: "Grande (acima de 10 kg)",
      message: "Mensagem",
      submit: "Enviar",
      success: "Obrigada! Entraremos em contato em breve 🐾",
      error: "Algo deu errado. Tente novamente.",
      placeholderName: "Como você se chama?",
      placeholderPhone: "+41 …",
      placeholderEmail: "seu@email.com",
      placeholderLocation: "Rua / Bairro",
      placeholderMessage: "Conte um pouco sobre seu pet e o que você precisa…",
    },
    footer: {
      tagline: "Petsitter carinhosa em Embrach.",
      quick: "Acesso rápido",
      legal: "Legal",
      agb: "Termos",
      privacy: "Privacidade",
      social: "Siga a gente",
      rights: "© 2026 Caroline Sousa · carol-tierbetreuung.ch",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      gallery: "Gallery",
      faq: "FAQ",
      contact: "Contact",
      cta: "Book now",
    },
    hero: {
      title: "Your pet is in the best hands",
      subtitle:
        "Loving care for dogs and cats in Embrach. Because your furry friend deserves more than care — they deserve true affection.",
      ctaPrimary: "Explore services",
      ctaSecondary: "Get in touch",
      badge: "With love since 2023",
    },
    banner: {
      title: "On maternity leave!",
      text: "I'm currently on maternity leave and temporarily not accepting new bookings. Want to be notified when I'm back?",
      cta: "Join the waitlist",
      formTitle: "Join the waitlist",
      formSubtitle: "Leave your name and email — I'll get in touch as soon as I'm back.",
      namePh: "Your name",
      emailPh: "Your email",
      submit: "Subscribe",
      success: "Thanks! You're on the list 🐾",
      already: "This email is already registered.",
    },
    services: {
      title: "What we do for you",
      subtitle: "Three services with one goal: your pet feeling completely at home.",
      tax: "Prices excl. VAT",
      walk: {
        title: "Dog walks",
        text: "Every walk is a little adventure. Your dog leaves full of energy and comes back happy, tired and tail-wagging.",
        p1: "Per walk & dog",
        p1v: "CHF 35",
        p2: "Additional dog (same family)",
        p2v: "CHF 25",
        p3: "Solo walk (on request)",
        p3v: "CHF 50",
      },
      day: {
        title: "Day care",
        text: "A safe environment full of play and company. Your dog socializes, has fun and keeps their routine.",
        p1: "Full day",
        p1v: "CHF 65",
        p2: "Half day",
        p2v: "CHF 50",
      },
      cat: {
        title: "Cat sitting",
        text: "Cats need attention — best in the comfort of their own home. Daily visits to feed, play and make sure they feel loved.",
        p1: "Visit 1× daily",
        p1v: "CHF 35",
        p2: "Visit 2× daily",
        p2v: "CHF 55",
        p3: "Each additional cat (same home)",
        p3v: "+CHF 5/day",
      },
    },
    about: {
      kicker: "About",
      title: "Hi, I'm Carol!",
      p1: "I'm Caroline Sousa, and my passion for animals has been with me since childhood. As a petsitter in Embrach I look after dogs and cats with the same affection I'd want for my own. Every animal has their own personality — and that's exactly what I love.",
      p2: "When I look after your pet, you're not just a booking. You become part of my little animal family.",
      badge: "With love since 2023",
    },
    why: {
      title: "What makes us special",
      subtitle: "Four reasons pet parents trust us.",
      items: [
        { title: "Familiar surroundings", text: "Care at home, where your pet feels most comfortable." },
        { title: "Genuine affection", text: "Not a job. Just love for animals." },
        { title: "Local & reliable", text: "In Embrach, always reachable." },
        { title: "Officially registered", text: "Approved by Veterinäramt Kanton Zürich." },
      ],
    },
    gallery: {
      title: "Moments full of joy",
      subtitle: "A little glimpse of our everyday with dogs and cats.",
    },
    testimonials: {
      title: "What pet parents say",
      subtitle: "Sample voices — to be replaced with real reviews.",
      note: "* Placeholder texts. To be replaced with real reviews.",
      items: [
        { name: "Maria & Max", pet: "🐕", text: "Carol takes care of Max like he's her own. We travel relaxed — Max loves her!" },
        { name: "Daniel & Luna", pet: "🐱", text: "Luna is shy but blossoms with Carol. Daily updates with photos — perfect." },
        { name: "Sandra & Bobby", pet: "🐕", text: "Reliable, warm and always reachable. We recommend Carol wholeheartedly." },
      ],
    },
    faq: {
      title: "Common questions",
      subtitle: "Everything you might want to know before booking.",
      items: [
        { q: "How does the first contact work?", a: "Send me a short message via the form or call. We arrange a free meet-and-greet at your home so I can get to know your pet in a relaxed setting." },
        { q: "Do you also care for puppies or senior dogs?", a: "Yes, gladly. Puppies and seniors need special attention — we adjust pace, walks and breaks to their needs." },
        { q: "What if my pet gets sick?", a: "I notify you immediately and follow your instructions. In an emergency I take your pet to your vet or to the nearest emergency clinic." },
        { q: "Can I book at short notice?", a: "If my availability allows — yes. Please call directly and we'll find the best solution together." },
        { q: "Are the prices negotiable?", a: "Prices are fairly calculated. For long-term bookings or several pets in the same household, we'll find an individual solution." },
      ],
    },
    contact: {
      title: "Write to us!",
      subtitle: "Tell me about your furry friend. I'll get back to you within 24 hours.",
      info: "Contact info",
      hours: "Mon – Fri · 08:00 – 18:30",
      city: "Embrach, Canton of Zurich",
      name: "Name",
      phone: "Phone",
      email: "Email",
      location: "Address / Place",
      service: "Service type",
      spaziergang: "Walk",
      tagesbetreuung: "Day care",
      katzenbetreuung: "Cat sitting",
      dogCount: "How many dogs?",
      dogSize: "Dog size",
      sizeSmall: "Small (up to 10 kg)",
      sizeLarge: "Large (10 kg and up)",
      message: "Message",
      submit: "Send",
      success: "Thanks! We'll be in touch soon 🐾",
      error: "Something went wrong. Please try again.",
      placeholderName: "What's your name?",
      placeholderPhone: "+41 …",
      placeholderEmail: "you@email.com",
      placeholderLocation: "Street / Area",
      placeholderMessage: "Tell me a little about your pet and your needs…",
    },
    footer: {
      tagline: "Loving petsitter in Embrach.",
      quick: "Quick links",
      legal: "Legal",
      agb: "Terms",
      privacy: "Privacy",
      social: "Follow us",
      rights: "© 2026 Caroline Sousa · carol-tierbetreuung.ch",
    },
  },
};

export const defaultLang = "de";
